import { useEffect, useState } from "react";
import { useCartStore } from "../../store/useCartStore";
import { useAddItem, useDecreaseItem } from "../apis/cart";
import { useUserStore } from "../../store/useUserStore";

const useChanegeCart = () => {
  const { setShopping, addItem, removeItem, setCart, cart, setLoading } =
    useCartStore((state) => state);
  const user = useUserStore((state) => state.user);
  const {
    data: dataAddItem,
    mutate: mutateAddItem,
    isLoading: isLoadingAddItem,
    isSuccess: isSuccessAddItem,
    isError: isErrorAddItem,
  } = useAddItem();
  const {
    data: dataRemoveItem,
    mutate: mutateRemoveItem,
    isLoading: isLoadingRemoveItem,
    isSuccess: isSuccessRemoveItem,
    isError: isErrorRemoveItem,
  } = useDecreaseItem();

  const [item, setItem] = useState(null);

  const addToCart = (item) => {
    if (!user.auth) {
      document.querySelector(".loginModal").classList.add("active");
      document.querySelector(".modal").classList.add("active");
      return;
    }

    setItem(item);
    addItem(item);
    setLoading(true);
    mutateAddItem({ product_id: item.product_id });
  };

  const removeFromCart = (item) => {
    if (!user.auth) {
      document.querySelector(".loginModal").classList.add("active");
      document.querySelector(".modal").classList.add("active");
      return;
    }
    const getItem = cart.find((i) => i.product_id === item.product_id);
    setItem(item);
    removeItem(item);
    setLoading(true);
    mutateRemoveItem({ cart_item_id: getItem.cart_item_id });
  };

  useEffect(() => {
    setLoading(false);
    if (isSuccessAddItem) {
      setCart(dataAddItem.data?.products);
      const data = dataAddItem.data?.shopping_cart;
      delete data.items;

      setShopping(dataAddItem.data?.shopping_cart);
    }
    if (isErrorAddItem) {
      removeItem(item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessAddItem, isErrorAddItem]);

  useEffect(() => {
    setLoading(false);

    if (isSuccessRemoveItem) {
      const data = dataRemoveItem.data?.shopping_cart;
      delete data.products;

      setShopping(dataRemoveItem.data?.shopping_cart);
    }
    if (isErrorRemoveItem) {
      addItem(item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessRemoveItem, isErrorRemoveItem]);

  return { addToCart, removeFromCart };
};

export default useChanegeCart;
